import type { EpicLink } from '@atlassian/jira-shared-types';
import createEntry from '../../common/utils/api';
import { props } from './constants';

export default createEntry<EpicLink>(props);
